import FeathersHelper from "../../helpers/feathers";

export const find = payload => FeathersHelper.find('users', payload);
export const create = payload => FeathersHelper.create('users', payload);
export const patch = (id, payload) => FeathersHelper.patch('users', id, payload);
export const remove = (id, params = {}) => FeathersHelper.remove('users', id, params);